import {Button, Stack, Typography} from '@mui/material';
import {ConfirmationDrawerEnum} from 'main/analytics/gaTagsEnum';
import {PlanTypeChip} from 'presentation/components';
import {usePersonalData} from 'presentation/hooks';
import {useBookingConfirmationDrawer} from 'presentation/pages/private/booking/hooks/useBookingConfirmationDrawer';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import React from 'react';
import {StyledStack} from './styles';

const {change} = translations['pt-br'].commons;

const ChangeBeneficiaryCard = () => {
	const {userName} = usePersonalData();
	const {
		beneficiary: {nmPlano},
	} = useAccountInformation();
	const {handleChangeBeneficiary} = useBookingConfirmationDrawer();

	return (
		<StyledStack>
			<Stack
				direction="column"
				justifyContent="flex-start"
				alignItems="flex-start"
				spacing={0.5}
				flex={1}>
				<Typography color="text.primary" variant="label">
					{formatText(userName)}
				</Typography>
				<Typography color="text.primary" variant="body1">
					{nmPlano}
				</Typography>
				<PlanTypeChip />
			</Stack>
			<Button
				variant="text"
				onClick={handleChangeBeneficiary}
				data-tag-id={ConfirmationDrawerEnum.CLICK_ALTERAR_PLANO_CONFIRMACAO_DADOS}>
				{change}
			</Button>
		</StyledStack>
	);
};

export {ChangeBeneficiaryCard};
